import React from 'react';
import { useParams } from 'react-router-dom';
import PageContent from '../../../components/Main/Content/mainContent';
import ServiceSearch from '../../../components/Services/Search/serviceSearch';

const ProdutoPesquisar = () => {
  const { id } = useParams();
  return (
    <PageContent>
      <ServiceSearch referenceId={id} />
    </PageContent>
  );
};

export default ProdutoPesquisar;
